import React, { PureComponent } from "react";

class RadioButtonGroup extends PureComponent {

    render() {

      const { Validaciones, ValidarPantalla, GET_AGRUPAMIENTO, Cuenta, guardarCampoCuenta } = this.props;

      if (GET_AGRUPAMIENTO.length > 0) {
        const radioAgrupamientos = GET_AGRUPAMIENTO.map((agrupamiento, index) => {
        let estaSeleccionado = (agrupamiento.Id == Cuenta.AgrupamientoVisaId);

        return (
        <div className="col-xs-4" key={"agrupamiento-" + index} >
            <div className="container-radio radio-margin">
                <input type="radio" name="agrupamiento" value={agrupamiento.Id} id={"agrupamiento-radio-" + index}
                    checked={estaSeleccionado}
                    onChange={(event) => guardarCampoCuenta(event.target.value, "AgrupamientoVisaId")} />
                <label className="lbl-radio label-secondary" htmlFor={"agrupamiento-radio-" + index}>{agrupamiento.Descripcion}</label>
            </div>
        </div>
        );

      });

      let mensajeError = null;
      if (ValidarPantalla == true) {
         if (Validaciones.AgrupamientoSeleccionado == false) {
             mensajeError = <label className="error">Debe seleccionar un agrupamiento</label>;
         }
      }

      return (
      <div className="bottom-separator-xs">
        <div className="row">
           <div className="col-xs-12">
              <label className="label-primary">Agrupamiento</label>
           </div>
       </div>
       <div className="row">
         <div className="col-xs-12">
             {radioAgrupamientos}
         </div>
         <div className="col-xs-12">
             {mensajeError}
         </div>
       </div>
      </div>
      );
      }
      else {
        return null;
      }

    }

}

export default RadioButtonGroup;